
import { EntityDto, IEntityDto } from "../../../utils/models/entity-dto";
import { FieldType } from "@gbs-platform-client/fwk-core";


export class RoleMaster extends EntityDto implements IEntityDto{
  Role_Id: number;
  Role_Name:string;
  Status_Id:number;



  constructor() {
    super();
      this.Role_Id = 0;
      this.Role_Name = "";
      this.Status_Id = 1;


this.EntityMetaData = [
  {FieldName:'Role_Name',FieldType:FieldType.String,IsMandatory:true,ValidationMessage:'Role is required'},
];
  }}

